<template>
  <div class="ChatChartSupervise-container" v-loading="EmployeeLoading">
    <el-dialog :title="chatTitle" v-if="dialogVisible" :visible.sync="dialogVisible" class="chat-content-dialog"
      :close-on-click-modal="true" :center="true" width="600px" :close-on-press-escape="true" @close="close">
      <template #title>
        <h3>{{ parmsM.currentMan }}与{{ parmsM.withMan }}的聊天摘要</h3>
        <p>{{ parmsM.date }} {{ parmsM.label }}</p>
      </template>
      <chatContent :rowData="rowData" :parmsM="parmsM" />
    </el-dialog>

    <div class="ChatChartSupervise-l">
      <el-select size="small" class="select-stafft-wrap" v-model="params.userId" filterable placeholder="请选择" clearable>
        <el-option v-for="item in options" :key="item.staffUserId" :label="item.name" :value="item.staffUserId">
        </el-option>
      </el-select>
      <div class="employee-area">
        <div v-for="(item, index) in handleEmployee" :key="index" @click="clickCurrentEm(item)" :class="[
          'employee-item',
          { 'seleted-item': item.staffUserId == seletedEmployeeId }, { 'disabled-item': DateLoading || seletedEmployeeId == item.staffUserId },
        ]">
          <li class="li-1">
            <h3>{{ item.name }}</h3>
            <span>{{ item.deptName }}</span>
          </li>
          <li class="li-2">最近聊天：{{ item.leastChatTime }}</li>
        </div>
      </div>
    </div>
    <div class="ChatChartSupervise-r" v-loading="DateLoading" v-if="!errorText">
      <div class="title-row">
        <span>{{ seletedEmployeeName }}近期与客户聊天情况摘要</span>
        <div class="date-row">
          <i :class="['el-icon-arrow-left', 'btn', { 'disabled-i': handleDisabled() }]" @click="changeDate(0)"></i>
          <el-date-picker :disabled="handleDisabled()" style="width: 330px;" size="small" :clearable="false"
            v-model="selectedWeek" type="week" :format="`yyyy 年 第 WW 周 （ ${startTimeM} 至 ${endTimeM} ）`"
            :picker-options="pickerOptions" @change="handleWeekChange">
          </el-date-picker>
          <i :class="['el-icon-arrow-right', 'btn', { 'disabled-i': handleDisabled() }]" @click="changeDate(1)"></i>
        </div>
        <span></span>
      </div>

      <div class="content-mian">
        <div class="content-mian-box" v-if="DateOptions && DateOptions.length">
          <div v-for="(item, index) in DateOptions" :key="index" class="date-item">
            <div class="date-title">
              <li class="li-1">{{ item.dateM }}({{ item.label }})</li>
              <li class="li-2">
                共沟通<span>{{ item.total || 0 }}</span>位客户
              </li>
            </div>
            <div class="date-contet" ref="scrollContainer" @scroll="handleScroll(index)">
              <div v-for="(itemD, indexD) in item.dataArr" :key="indexD" class="dataArr-item"
                @click="openView(itemD, item)">
                <li class="li-1">
                  <div> {{ itemD.earliestTime }} 开始</div>
                  <div>
                    总计<span>{{ itemD.totalChatNum }}</span>条
                  </div>
                </li>
                <li class="li-2">
                  与<span>{{ itemD.externalUserName || '--' }}</span>聊天
                </li>
              </div>
              <div v-if="handleParamsBack(index, 'loading')" class="loading-text">
                <i class="el-icon-loading"></i> 加载中...
              </div>
              <div v-if="handleParamsBack(index, 'noMore') && !handleParamsBack(index, 'loading')" class="no-more">
                没有更多数据了
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ChatChartSupervise-r" v-else>
      <div class="errorText-main">
        <img class="img" src="../../../assets/img/not-found.svg" alt="404">
        <span>
          {{ errorText }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  staffListApi,
  chartPageApi,
} from "@/api/chatChartSupervise.js";
import chatContent from "./chatContent.vue";

export default {
  name: "ChatChartSupervise",
  components: {
    chatContent,
  },

  data() {
    return {
      dialogVisible: false,
      chatTitle: "",
      rowData: null,
      parmsM: null,
      EmployeeLoading: false,
      params: {
        userId: null,
      },
      options: [],
      /**选中的员工 */
      seletedEmployeeId: "",
      seletedEmployeeName: "",
      /**当前员工  是否开通会话存档权限，true：已开通权限，false：未开通权限 */
      currentPermission: false,
      /**内容区域异常显示的文本 */
      errorText: '',
      DateLoading: false,
      /**一周聊天情况摘要数据 */
      DateOptions: [{
        key: "0",
        date: null,
        label: "星期一",
        total: 0,
        dataArr: [],
      },
      {
        key: "1",
        label: "星期二",
        total: 0,
        dataArr: [],
      },
      {
        key: "2",
        label: "星期三",
        total: 0,
        dataArr: [],
      },
      {
        key: "3",
        label: "星期四",
        total: 0,
        dataArr: [],
      },
      {
        key: "4",
        label: "星期五",
        total: 0,
        dataArr: [],
      },
      {
        key: "4",
        label: "星期六",
        total: 0,
        dataArr: [],
      },
      {
        key: "4",
        label: "星期日",
        total: 0,
        dataArr: [],
      },],
      selectedWeek: null,
      pickerOptions: {
        firstDayOfWeek: 1, // 设置周一为一周的第一天（可选）
      },
      startTimeM: null,
      endTimeM: null,
      /**星期一相关参数 */
      params0: {
        loading: false,
        page: 1, // 当前页码
        size: 20, // 每页条数
        noMore: false, // 是否无更多数据
        lastScrollTop: 0, // 新增：记录上次滚动位置
        total: 0, // 总条数
      },
      /**星期二相关参数 */
      params1: {
        loading: false,
        page: 1, // 当前页码
        size: 20, // 每页条数
        noMore: false, // 是否无更多数据
        lastScrollTop: 0, // 新增：记录上次滚动位置
        total: 0, // 总条数
      },
      /**星期三相关参数 */
      params2: {
        loading: false,
        page: 1, // 当前页码
        size: 20, // 每页条数
        noMore: false, // 是否无更多数据
        lastScrollTop: 0, // 新增：记录上次滚动位置
        total: 0, // 总条数
      },
      /**星期四相关参数 */
      params3: {
        loading: false,
        page: 1, // 当前页码
        size: 20, // 每页条数
        noMore: false, // 是否无更多数据
        lastScrollTop: 0, // 新增：记录上次滚动位置
        total: 0, // 总条数
      },
      /**星期五相关参数 */
      params4: {
        loading: false,
        page: 1, // 当前页码
        size: 20, // 每页条数
        noMore: false, // 是否无更多数据
        lastScrollTop: 0, // 新增：记录上次滚动位置
        total: 0, // 总条数
      },
      /**星期六相关参数 */
      params5: {
        loading: false,
        page: 1, // 当前页码
        size: 20, // 每页条数
        noMore: false, // 是否无更多数据
        lastScrollTop: 0, // 新增：记录上次滚动位置
        total: 0, // 总条数
      },
      /**星期日相关参数 */
      params6: {
        loading: false,
        page: 1, // 当前页码
        size: 20, // 每页条数
        noMore: false, // 是否无更多数据
        lastScrollTop: 0, // 新增：记录上次滚动位置
        total: 0, // 总条数
      },

      timeout: null
    };
  },
  computed: {
    /**处理过滤的员工 */
    handleEmployee() {
      console.log("处理选中的员工", this.params.userId);
      let res = [];
      if (this.params.userId) {
        let res11 =
          this.options.find((v) => {
            return v.staffUserId == this.params.userId;
          }) || null;

        console.log("处理选中的员工----", res11);
        res = res11 ? [res11] : [];
      } else {
        res = this.options;
      }
      return res;
    },
  },
  mounted() {
    this.getEmployeeData();
  },
  methods: {
    handleDisabled() {
      // return true
      return this.params0.loading || this.params1.loading || this.params2.loading || this.params3.loading || this.params4.loading || this.params5.loading || this.params6.loading
    },
    /**上一周  下一周 */
    changeDate(val) {
      if (this.handleDisabled()) {
        return
      }
      let res = null
      const [year, month, day] = this.startTimeM.split('-').map(Number); // 假设输入的日期格式为 'yyyy-mm-dd'
      const date = new Date(year, month - 1, day); // 月份是从0开始的，所以需要减1
      switch (val) {
        case 0:
          // 减去7天
          date.setDate(date.getDate() - 7);
          // 使用toLocaleDateString进行格式化，然后手动提取需要的部分
          const formattedDate = date.toLocaleDateString('en-US').split('/').map(part => part.padStart(2, '0')).join(' ');
          res = `${formattedDate.slice(6, 10)}-${formattedDate.slice(0, 2)}-${formattedDate.slice(3, 5)}`; // 提取并重组为 'yyyy mm dd'
          break;
        case 1:
          // 加7天
          date.setDate(date.getDate() + 7);
          // 使用toLocaleDateString进行格式化，然后手动提取需要的部分
          const formattedDate1 = date.toLocaleDateString('en-US').split('/').map(part => part.padStart(2, '0')).join(' ');
          res = `${formattedDate1.slice(6, 10)}-${formattedDate1.slice(0, 2)}-${formattedDate1.slice(3, 5)}`; // 提取并重组为 'yyyy mm dd'
          break;

        default:
          break;
      }

      console.log('changeDate', res,);
      if (res) {
        this.selectedWeek = new Date(res)
        this.handleWeekChange()
      }
    },
    /**选中日期 */
    handleWeekChange(value, getData) {
      let valueM = value
      if (!value) {
        valueM = this.selectedWeek
      }
      const weekStart = new Date(valueM);
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekEnd.getDate() + 6); // 获取周日的日期

      this.startTimeM = weekStart.toISOString().slice(0, 10)
      this.endTimeM = weekEnd.toISOString().slice(0, 10)
      console.log('周一:', this.startTimeM, valueM); // ISO格式的日期字符串
      console.log('周日:', this.endTimeM); // ISO格式的日期字符串

      if (this.startTimeM) {

        const dates = [];
        let currentDate = new Date(this.startTimeM);

        for (let i = 0; i < 7; i++) {
          dates.push((new Date(currentDate)).getTime()); // 复制当前日期，避免修改原始日期对象
          currentDate.setDate(currentDate.getDate() + 1); // 将日期增加一天
        }

        console.log('七天:', dates); // ISO格式的日期字符串
        if (dates && dates.length) {
          this.DateOptions.forEach((v, index) => {
            if (dates[index]) {
              v.date = this.formatDate(dates[index], '-')
              v.dateM = this.formatDate(dates[index], '+')
            }
          })
        }

        !getData ? this.getEmployeeChartData() : ''
      }
    },
    /**时间戳格式化 */
    formatDate(timestamp, val) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return val == '-' ? `${year}-${month}-${day}` : `${year}年${month}月${day}日`
    },
    /**默认当前一周 */
    defaultDate() {
      const today = new Date()
      const day = today.getDay();
      const diff = today.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
      this.selectedWeek = new Date(today.setDate(diff))
      console.log(123, diff, this.selectedWeek);
      // return new Date(date.setDate(diff));
      this.handleWeekChange(this.selectedWeek, true)
    },

    handleParamsBack(index, key) {
      let res = null
      if (key in this[`params${index}`]) {
        res = this[`params${index}`][key]
      }
      return res
    },
    // 滚动事件处理
    handleScroll: _.throttle(function (index) {
      if (this[`params${index}`].loading || this[`params${index}`].noMore)
        return;
      const container = this.$refs.scrollContainer[index];
      const currentScrollTop = container.scrollTop;

      // 关键修复：只处理向下滚动的情况
      if (currentScrollTop <= this[`params${index}`].lastScrollTop) {
        this[`params${index}`].lastScrollTop = currentScrollTop;
        return; // 向上滚动时直接返回
      }

      // 更新滚动位置记录
      this[`params${index}`].lastScrollTop = currentScrollTop;

      console.log(
        "触底判断------",
        index,
        this.$refs.scrollContainer,
        container.scrollTop,
        container.clientHeight,
        container.scrollHeight
      );
      // 触底判断（只在向下滚动时执行）
      const scrollBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight;
      if (scrollBottom <= 50) {
        console.log("触底判断（距离底部50px时加载）");
        this[`params${index}`].page++;
        this.getEmployeeChartDateData(index);
      }
    }, 200),

    /** 打开聊天摘要 */
    openView(item, dateItem) {
      console.log("打开聊天摘要", item, dateItem);
      this.rowData = item
      this.parmsM = {
        //  当前员工
        currentMan: this.seletedEmployeeName,
        //  和谁聊天
        withMan: item.externalUserName,
        //  时间
        date: dateItem.date,
        dateM: dateItem.dateM,
        //  星期
        label: dateItem.label,
      }
      this.dialogVisible = true;
    },
    /** 弹窗关闭 */
    close() {
      console.log("弹窗关闭");
      this.dialogVisible = false;
    },
    /**获取员工数据 */
    async getEmployeeData() {
      console.log("getEmployeeData-----", this.params);
      this.EmployeeLoading = true;
      const res = await staffListApi(
        localStorage.getItem("Authorization")
      );
      this.EmployeeLoading = false
      console.log("获取员工数据", res);
      if (res.error.code == 200 && res.data) {
        if (res.data.length) {
          this.options = res.data
          this.seletedEmployeeId = this.options[0].staffUserId;
          this.seletedEmployeeName = this.options[0].name;
          this.currentPermission = this.options[0].isPermission || false
          this.defaultDate()
          this.errorText = ''
          this.getEmployeeChartData();
        } else {
          this.options = []
          this.errorText = '暂无员工数据'
          this.$message.warning("暂无员工数据");
        }
      }
    },
    /**选中员工 */
    clickCurrentEm(item) {
      if (this.DateLoading || this.seletedEmployeeId == item.staffUserId) return;
      this.errorText = ''
      this.DateLoading = true;
      this.seletedEmployeeId = item.staffUserId;
      this.seletedEmployeeName = item.name;
      this.currentPermission = item.isPermission || false
      this.defaultDate()
      this.getEmployeeChartData();
    },

    /**获取一周的聊天数据 */
    async getEmployeeChartData() {
      console.log("获取员工聊天数据-----", this.currentPermission);
      this.DateLoading = true;

      if (this.currentPermission) {
        this.DateLoading = false
        // 重置数据
        this.DateOptions.forEach(v => {
          v.dataArr = []
          v.total = null
        })
        this.resetParams();
        this.getEmployeeChartDateData(0)
        this.getEmployeeChartDateData(1)
        this.getEmployeeChartDateData(2)
        this.getEmployeeChartDateData(3)
        this.getEmployeeChartDateData(4)
        this.getEmployeeChartDateData(5)
        this.getEmployeeChartDateData(6)
        setTimeout(() => {
          for (let i = 0; i < 7; i++) {
            if (this.$refs.scrollContainer[i]) {
              this[`params${i}`].lastScrollTop =
                this.$refs.scrollContainer[i].scrollTop;
            }
          }
        }, 500);
      } else {
        this.DateLoading = false
        this.errorText = '员工未开通会话存档，请联系管理员开通'
      }
    },
    /**重置参数 */
    resetParams() {
      for (let i = 0; i < 7; i++) {
        if (this[`params${i}`]) {
          this[`params${i}`].loading = false;
          this[`params${i}`].page = 1;
          this[`params${i}`].noMore = false;
          this[`params${i}`].lastScrollTop = 0;
          this[`params${i}`].total = 0;
        }
      }
    },
    /**获取某天员工聊天数据 */
    getEmployeeChartDateData(index) {
      return new Promise(async (resolve, reject) => {

        console.log("获取某天员工聊天数据-----", this[`params${index}`], this.DateOptions[index]);
        this[`params${index}`].loading = true;


        const res = await chartPageApi(
          {
            currentDate: this.DateOptions[index].dateM,
            staffUserId: this.seletedEmployeeId,
            page: this[`params${index}`].page,
            size: this[`params${index}`].size,
          },
          localStorage.getItem("Authorization")
        );
        this[`params${index}`].loading = false;
        console.log("获取某天员工聊天数据-----111", res);
        if (res.error.code == 200 && res.data.result) {
          if (!res.data.total) {
            this[`params${index}`].noMore = true
            return
          }
          this[`params${index}`].total = res.data.total;
          this.DateOptions[index].total = res.data.total;
          this.DateOptions[index].dataArr.push(...res.data.result);

          if (
            this[`params${index}`].page * this[`params${index}`].size >= res.data.total
          ) {
            this[`params${index}`].noMore = true
          } else {
            this[`params${index}`].noMore = false
          }
          resolve(true)
        } else {
          this[`params${index}`].noMore = true
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  display: none !important;
}

/deep/.el-dialog__body,
/deep/.el-dialog,
/deep/.el-pager li {
  padding: 0;
  background-color: transparent;
  border-radius: 8px;
  overflow: hidden;
}

.ChatChartSupervise-container {
  display: flex;
  width: 100%;
  height: 100%;

  li,
  h3 {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .ChatChartSupervise-l {
    padding-right: 14px;
    width: 214px;
    height: 100%;
    box-sizing: border-box;
    border-right: 1px solid rgba(238, 239, 243, 1);
    display: flex;
    flex-direction: column;
    gap: 14px;
    overflow: hidden;

    .select-stafft-wrap {
      width: 200px;
    }

    .employee-area {
      flex: 1;
      overflow: auto;

      .seleted-item {
        position: relative;

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          border-radius: 4px;
          box-sizing: border-box;
          border: 1px solid rgba(38, 132, 255, 1);
        }
      }

      .disabled-item {
        cursor: no-drop !important;
      }

      .employee-item {
        border: 1px solid rgba(238, 239, 243, 1);
        border-radius: 4px;
        padding: 8px 12px;
        margin-bottom: 8px;

        &:hover {
          cursor: pointer;
        }

        .li-1 {
          display: flex;
          align-items: center;
          gap: 8px;
          line-height: 22px;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
          margin-bottom: 7px;

          h3 {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.9);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          span {
            background: rgba(162, 174, 181, 0.2);
            border-radius: 4px;
            line-height: 20px;
            padding: 0 8px;
            color: rgba(96, 98, 102, 1);
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
        }

        .li-2 {
          line-height: 22px;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }

  .ChatChartSupervise-r {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 14px;

    .title-row {
      line-height: 40px;
      height: 40px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      margin-bottom: 8px;

      /deep/.el-input--suffix .el-input__inner {
        padding-right: 0;
      }

      span {
        display: block;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.9);
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }

      .date-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        .btn {
          border: 1px solid rgba(230, 233, 235, 1);
          border-radius: 100%;
          padding: 4px;
        }

        .disabled-i {
          cursor: no-drop;
          background-color: #f5f7fa !important;
          color: #C0C4CC !important;

        }
      }
    }

    .content-mian {
      flex: 1;
      overflow: hidden;

      .content-mian-box {
        height: 100%;
        overflow: hidden;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        border-radius: 4px;
        border: 1px solid rgba(238, 239, 243, 1);
        box-sizing: border-box;

        .date-item {
          overflow: hidden;
          display: flex;
          flex-direction: column;

          // background: darkgray;
          &:not(:last-child) {
            border-right: 1px solid rgba(238, 239, 243, 1);
          }

          .date-title {
            background: rgba(230, 232, 234, 0.49);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 64px;
            gap: 4px;

            .li-1 {
              line-height: 22px;
              color: rgba(48, 49, 49, 1);
              font-weight: 500;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
            }

            .li-2 {
              display: flex;
              line-height: 22px;
              font-size: 14px;
              color: rgba(79, 94, 123, 1);
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;

              span {
                margin: 0 2px;
                color: rgba(38, 132, 255, 1);
              }
            }
          }

          .date-contet {
            flex: 1;
            overflow: auto;
            padding: 4px;
            box-sizing: border-box;

            .dataArr-item {
              border-radius: 4px;
              overflow: hidden;
              position: relative;
              padding: 8px 12px;
              background: rgba(240, 249, 255, 1);

              &:hover {
                cursor: pointer;
              }

              &::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 4px;
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                box-sizing: border-box;
                background: rgba(38, 132, 255, 1);
              }

              &:not(:last-child) {
                margin-bottom: 4px;
              }

              .li-1 {
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                color: rgba(96, 98, 102, 1);
                margin-bottom: 4px;
                overflow: hidden;
                line-height: 16px;

                div {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }

                span {
                  margin: 0 2px;
                  color: rgba(38, 132, 255, 1);
                }
              }

              .li-2 {
                font-size: 14px;
                font-weight: 500;
                color: rgba(18, 25, 36, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;

                span {
                  margin: 0 2px;
                }
              }
            }

            .loading-text {
              text-align: center;
              font-size: 12px;
              margin: 10px 0;
            }

            .no-more {
              text-align: center;
              font-size: 12px;
              margin: 10px 0;
            }
          }
        }
      }
    }
  }

  .errorText-main {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    .img {
      height: 200px;
      width: 200px;
    }

    span {
      color: #4F5E7B;
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>
